<template>
  <div>
    
    <div class="rounded">
      <div class="">
        <div v-if="member.plan === 'free' || member.plan === null">
          
          <div class="pb-8">
            <div class="pb-4 text-lg font-bold">Subscription</div>
            <p class="mb-4 leading-normal"><a target="_blank" class="text-full-blue underline" href="https://www.tatatap.com/pricing">See subscription information</a></p>
            
            <div class="pb-4 flex items-center">
              <input v-model="plan" type="radio" name="subscription" value="month_basic" />
              <label class="pl-4">Monthly &mdash; $5 USD / month</label>
            </div>

            <div class="pb-4 flex items-center">
              <input v-model="plan" type="radio" name="subscription" value="year_basic" />
              <label class="pl-4">Annual &mdash; $50 USD / year</label>
            </div>
          </div>
          <div class="pb-8">
            <div class="pb-4 text-lg font-bold">Billing Info</div>
            
          <p v-if="error" class="text-red-dark pb-6">{{error}}</p>

          <div ref="card" class="bg-white py-3 px-4 border border-grey-lighter text-grey-darker rounded"></div>

          <input
            class="rounded mt-4 py-3 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
            v-model="promo"
            placeholder="Coupon Code" />


          <div class="flex justify-end mt-6">
            <t-button
              :disabled="loading || !member.email_verified"
              @click="upgrade()">
              <span v-if="loading">Loading...</span>
              <span v-else>Subscribe</span>
            </t-button>
          </div>
          </div>
          <p class="leading-normal mb-4 text-base">Your card will be charged <strong>{{chargeAmount}} less discounts on {{chargeDate}} and automatically each {{chargeInterval}} to renew your subscription.</strong> You can cancel your subscription any time from your <router-link to="/account">account page</router-link>.</p>
        </div>

        <div v-else>
          <p class="leading-normal mb-4 text-base">You are subscribed paying
            <strong>{{
                    ({year_basic: '$50 per year less discounts',
                      month_basic: '$5 per month less discounts'})[member.plan_name]
                    }}</strong>. <router-link to="/">Back home</router-link> | <a target="_blank" class="text-full-blue underline" href="https://www.tatatap.com/pricing">See subscription information.</a></p>

          
          <div class="flex mt-6">
            <div
              :class="{
                '': loading,
                'underline cursor-pointer text-full-blue': !loading
              }"
              :disabled="loading"
              @click="downgrade()">
              <span v-if="loading">Loading...</span>
              <span v-else>Cancel subscription</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
 import {DateTime} from 'luxon';
 
 // import api from '@/api';
 import {mapState, mapActions} from 'vuex';
 const Stripe = window.Stripe || function () {};
 let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);

 export default {
   components: {  },

   data () {
     return {
       plan: 'year_basic',
       loading: false,
       promo: ''
     }
   },

   computed: {
     ...mapState({
       member: state => state.member,
       error: state => state.subscriptionError
     }),

     chargeAmount () {
       return ({year_basic: '$50 USD', month_basic: '$5 USD'})[this.plan];
     },

     chargeDate () {
       return DateTime.local().toFormat('LLLL dd, yyyy');
     },

     chargeInterval() {
       return ({year_basic: 'year', month_basic: 'month'})[this.plan];
     }
   },

   mounted: function () {
     this.showCard();
   },

   created () {
     this.elements = stripe.elements();
     this.card = undefined;
   },

   destroyed () {
     this.card.unmount();
     this.card.destroy();
   },

   methods: Object.assign(mapActions(['upgradeSub', 'downgradeSub']), {
     upgrade: async function () {
       let self = this;

       const res = await stripe.createToken(this.card);

       if (res.error) {
         self.hasCardErrors = true;
         self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
         return;
       }
       this.loading = true;

       await this.upgradeSub({token: res.token, plan: this.plan, promo: this.promo});

       this.loading = false;

       // this.$router.push({name: 'account'})

       this.$forceUpdate();

       this.$nextTick(() => {
         this.showCard();
       });
     },

     downgrade: async function () {
       this.loading = true;

       if (confirm('Are you sure you want to cancel your subscription?')){
         await this.downgradeSub({subscriptionId: this.member.subscription_id})
       }

       this.loading = false;
       this.$forceUpdate();

       this.$nextTick(() => {
         this.showCard();
       })
     },

     showCard: function () {
       if (typeof this.card === 'undefined') {
         this.card = this.elements.create('card');
       }

       if (this.member.plan === 'free' || this.member.plan === null) {
         this.card.mount(this.$refs.card);
       }
     }
   })
 };
</script>

